import { Box, BsArrowRight, Typography } from '@bymason-private/legacy-pattern-components';
import { HardwareListIcon, LogisticsListIcon, PLatformListIcon } from './list-icons';

export const BulletPointsSection = () => (
  <Box>
    <Typography variant='h6' fontWeight='bold' component='div' sx={{ mb: 3 }}>
      The Easiest Way to Build Smart Products at Scale
    </Typography>
    <Box
      sx={{
        display: 'flex',
        gap: 20,
        '& li': {
          listStyle: 'inside',
          ml: 1.5,
        },
      }}
    >
      <Box sx={{ maxWidth: 200 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <HardwareListIcon />
          <strong>Hardware</strong>
        </Box>

        <ul>
          <li>Tablets, handhelds, and wearables</li>
          <li>Accessories</li>
          <li>Custom devices</li>
        </ul>
      </Box>
      <Box sx={{ maxWidth: 200 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PLatformListIcon />
          <strong>Platform</strong>
        </Box>
        <ul>
          <li>Custom OS</li>
          <li>Tooling and APIs</li>
          <li>Fleet management</li>
          <li>Remote debugging</li>
        </ul>
      </Box>
      <Box sx={{ maxWidth: 200 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LogisticsListIcon />
          <strong>Logistics</strong>
        </Box>
        <ul>
          <li>Connectivity</li>
          <li>Provisioning</li>
          <li>Shipping</li>
          <li>Kitting</li>
        </ul>
      </Box>
    </Box>
    <Box sx={{ gap: 3, display: 'flex', mt: 3 }}>
      <a href='https://bymason.com/products/how-it-works/' target='_blank' rel='noopener noreferrer'>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography color='black'> How it works</Typography>
          <BsArrowRight fontWeight='bold' color='black' />
        </Box>
      </a>
      <a href='https://docs.bymason.com' target='_blank' rel='noopener noreferrer'>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography color='black'> View documentation</Typography>
          <BsArrowRight fontWeight='bold' color='black' />
        </Box>
      </a>
    </Box>
  </Box>
);
